import * as React from 'react';
import { History } from 'history';
import '../styles.css';
import aboutImage from '../../images/puzzle-2891875_1280.jpg';
import registerImage from '../../images/register-icon.svg';
import communityImage from '../../images/community-icon.svg';
import shareImage from '../../images/share-icon.svg';
import { CONTACT_PATH } from '../../constants';

interface IProps {
    history: History;
}

export default (props: IProps) => {
    const bgStyle = {
        backgroundImage: `url(${aboutImage})`,
        backgroundPosition: 'center -615px',
        padding: '200px 0 25px',
        color: '#fff'
    };
    const iconBGStyle: React.CSSProperties = {
        backgroundColor: '#29447B',
        borderRadius: '10px',
        padding: '30px 0',
        textAlign: 'center',
        marginBottom: '1em'
    };
    const imgStyle = {
        width: 'auto%',
        height: '80px',
        margin: '0 0 1em'
    };
    const offerStyle: React.CSSProperties = {
        backgroundColor: '#f1f1f1',
        padding: '20px',
        borderRadius: '10px',
        marginTop: '20px',
        textAlign: 'center'
    };

    return (
        <section className="aboutContent">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <section>
                            <h2>About Harmonize®</h2>
                            <p>Harmonize® is a cloud-based software application that serves as a powerful community resource and partnership management tool.  Features help clients facilitate collaborative online communities while providing a platform to aggregate, maintain and disseminate information on resources.  The application also supports resource mapping initiatives, powers resource directories and academic libraries, aids in referrals and more!</p>
                        </section>
                        <section>
                            <h2>How It Works</h2>
                            <div className="row">
                                <div className="col-md-4">
                                    <div style={iconBGStyle}>
                                        <img src={registerImage} style={imgStyle} />
                                    </div>
                                    <h3>Register on Harmonize<sup>®</sup></h3>
                                    <p>Any organization can sign up and register for a free Harmonize® account.</p>
                                </div>
                                <div className="col-md-4">
                                    <div style={iconBGStyle}>
                                        <img src={communityImage} style={imgStyle} />
                                    </div>
                                    <h3>Join a Community</h3>
                                    <p>Join a partner community to share information and communicate with other partners.</p>
                                </div>
                                <div className="col-md-4">
                                    <div style={iconBGStyle}>
                                        <img src={shareImage} style={imgStyle} />
                                    </div>
                                    <h3>Share Resources</h3>
                                    <p>Provide information on your organization, programs and services.</p>
                                </div>
                                <div className="col-sm-12">
                                    <p style={{ textAlign: 'center' }}>To host your own partner community on Harmonize®, <a href={CONTACT_PATH}>contact us</a> about subscription packages.</p>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h2>Why Harmonize ?</h2>
                            <p>Harmonize was purposely developed to help schools, NGOs and governmental agencies better manage community resources and partnerships.</p>
                            <p>Some reasons to Harmonize include:</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <h5>Information management, communication and alignment:</h5>
                                    <ul>
                                        <li>Centralized location for capturing, storing, maintaining and retrieving information on community partners and their resources.</li>
                                        <li>Fully customizable databases.</li>
                                        <li>Enhanced communication through in-app messaging.</li>
                                        <li>Helps align school, family & community resources.</li>
                                    </ul>
                                    <h5>Resource mapping companion: </h5>
                                    <ul>
                                        <li>Digitizes categorizing and maintaining an inventory of community assets.</li>
                                        <li>Customizable settings allow clients to gather and display information based on their preferences.</li>
                                    </ul>
                                    <h5>Referral facilitation:</h5>
                                    <ul>
                                        <li>Facilitates referrals; provides an efficient way to access vetted information on partners and services from any connected device.</li>
                                        <li>Settings allow for detailed information, including downloadable attachments (forms, brochures, etc.).</li>
                                        <li>Partners can update wait lists and other information in real-time.</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h5>Resource Directories/Academic Libraries:</h5>
                                    <ul>
                                        <li>Information stored in Harmonize® databases can be made available as online resource directories or academic libraries.</li>
                                        <li>Fully customizable search interface; embed into any webpage.</li>
                                        <li>Supports best practices; optimized for data integrity.</li>
                                    </ul>
                                    <h5>Maintain continuity amidst staff turnover:</h5>
                                    <ul>
                                        <li>Helps retain institutional knowledge and maintain relationships.</li>
                                        <li>Provides new employees with immediate access to essential information on partners and resources, in-app communication history, etc.</li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h2>Expert Consultation Available</h2>
                            <p>We also offer expert consultation from our highly experienced team of capacity builders to support development and implementation of accompanying educational and human services initiatives.  </p>
                        </section>
                        <section>
                            <h2><u>NOT</u> Your Normal Software Provider</h2>
                            <p>We understand how challenging it can be to effectively manage and maximize community partnerships and resources.  As consultants specializing in capacity building, we have worked for over 30 years across the United States and internationally to enhance education and human services.  We created Harmonize® to provide a better way to help schools, organizations and agencies build capacity, manage partnerships and resources, and improve access to information and services.  We see ourselves as a partner, not just a platform. Together, we can make a difference in your community and in the lives of those you serve.</p>
                        </section>
                        <section style={offerStyle}>
                            <h4 style={{ textAlign: 'center' }}>Interested in hosting your own partner community on Harmonize®?</h4>
                            <p style={{ textAlign: 'center' }}><a href={CONTACT_PATH}><strong>Contact us</strong></a> about subscription packages.</p>
                        </section>
                    </div>
                </div>
            </div >
        </section >
    )
}



// WEBPACK FOOTER //
// ./src/public/about/index.tsx